var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 115.785,
    viewBox: "0 0 380 115.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_password",
    transform: "translate(190 57.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_password-2",
    "data-name": "ill_password",
    transform: "translate(-190 -57.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126577",
    "data-name": "Path 126577",
    d: "M372.046,53.186A126.667,126.667,0,0,1,335.9,21.241c-6.549-8.347-13.933-13.211-22.559-8.069h0a31.1,31.1,0,0,1-29.463,1.533l-2.394-1.115a90.073,90.073,0,0,0-78.065.215L187.087,21.52a30.742,30.742,0,0,1-20.8,2.153,30.78,30.78,0,0,0-17.619,1.013h0a41.129,41.129,0,0,1-34.58-3.534C99.675,12.83,89.212,8.359,71.479,19.886h0c-16.34,10.6-32.338,19.583-35.707,42.167-3.116,20.875,9.842,37.025-4.091,49.932l-7.98,7.334H383.433C399.862,79.482,386.245,61.356,372.046,53.186Z",
    transform: "translate(-15.821 -4.801)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11649",
    "data-name": "Rectangle 11649",
    width: 21.863,
    height: 9.981,
    rx: 4.991,
    transform: "translate(121.345 25.429) rotate(-34.41)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126578",
    "data-name": "Path 126578",
    d: "M120.078,34.888a6.27,6.27,0,0,1-3.547-11.4l9.8-6.713A6.256,6.256,0,1,1,133.4,27.1l-9.8,6.713A6.156,6.156,0,0,1,120.078,34.888Zm9.791-16.695a3.8,3.8,0,0,0-2.1.646l-9.8,6.726a3.717,3.717,0,0,0,4.205,6.131l9.8-6.713a3.724,3.724,0,0,0-2.1-6.789Z",
    transform: "translate(8.223 -1.892)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11650",
    "data-name": "Rectangle 11650",
    width: 40.875,
    height: 64.828,
    rx: 4.269,
    transform: "translate(92.53 14.109)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11651",
    "data-name": "Rectangle 11651",
    width: 31.198,
    height: 47.639,
    transform: "translate(97.369 22.697)",
    fill: "#85b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126579",
    "data-name": "Path 126579",
    d: "M125.535,70.359H94.35L125.535,22.72Z",
    transform: "translate(3.019 -0.023)",
    fill: "#6da2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126580",
    "data-name": "Path 126580",
    d: "M125.157,23.317a.152.152,0,0,1,.152.152v46.5a.152.152,0,0,1-.152.152H95.1a.152.152,0,0,1-.152-.152v-46.5a.152.152,0,0,1,.152-.152h30.058m0-1.267H95.1a1.419,1.419,0,0,0-1.419,1.419v46.5A1.419,1.419,0,0,0,95.1,71.387h30.058a1.419,1.419,0,0,0,1.419-1.419v-46.5A1.419,1.419,0,0,0,125.157,22.05Z",
    transform: "translate(2.84 -0.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126581",
    "data-name": "Path 126581",
    d: "M127.4,82.289H95.053a5.523,5.523,0,0,1-5.523-5.523v-56.3a5.523,5.523,0,0,1,5.523-5.523H127.4a5.535,5.535,0,0,1,5.535,5.523v56.3a5.535,5.535,0,0,1-5.535,5.523ZM95.053,17.473a2.989,2.989,0,0,0-2.989,2.989v56.3a2.989,2.989,0,0,0,2.989,2.989H127.4a3,3,0,0,0,3-2.989v-56.3a3,3,0,0,0-3-2.989Z",
    transform: "translate(1.733 -2.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126582",
    "data-name": "Path 126582",
    d: "M4.383,0h7.169a3.293,3.293,0,0,1,3.293,3.293V5.472a3.293,3.293,0,0,1-3.293,3.293H4.383A4.383,4.383,0,0,1,0,4.319H0A4.383,4.383,0,0,1,4.383,0Z",
    transform: "translate(124.45 56.571) rotate(-34.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126583",
    "data-name": "Path 126583",
    d: "M121.732,58.018a5.371,5.371,0,0,1-1.089-.1,5.611,5.611,0,0,1-3.61-2.369,5.7,5.7,0,0,1-.861-4.243,5.611,5.611,0,0,1,2.343-3.6l5.941-4.015a4.56,4.56,0,0,1,6.333,1.267l1.267,1.811a4.56,4.56,0,0,1-1.267,6.333l-5.941,3.952a5.6,5.6,0,0,1-3.116.963Zm5.295-12.578a1.963,1.963,0,0,0-1.115.342L119.971,49.8a3.1,3.1,0,0,0-1.267,1.989,3.065,3.065,0,0,0,.469,2.343,3.129,3.129,0,0,0,4.319.836l5.941-4.015a2.039,2.039,0,0,0,.481-2.863l-1.267-1.811a2.039,2.039,0,0,0-1.685-.887Z",
    transform: "translate(8.811 5.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126584",
    "data-name": "Path 126584",
    d: "M4.991,0H15.466a3.585,3.585,0,0,1,3.585,3.585V6.4a3.585,3.585,0,0,1-3.585,3.585H4.991A4.991,4.991,0,0,1,0,4.991H0A4.991,4.991,0,0,1,4.991,0Z",
    transform: "matrix(0.897, -0.442, 0.442, 0.897, 120.563, 46.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126585",
    "data-name": "Path 126585",
    d: "M119.319,51.571A6.257,6.257,0,0,1,116.545,39.7l9.335-4.6a4.851,4.851,0,0,1,6.485,2.2l1.267,2.533a4.851,4.851,0,0,1-2.2,6.5l-9.4,4.623a6.333,6.333,0,0,1-2.711.608Zm8.753-14.465a2.242,2.242,0,0,0-1.013.241l-9.4,4.623a3.725,3.725,0,1,0,3.281,6.688l9.335-4.687a2.267,2.267,0,0,0,1.165-1.343,2.293,2.293,0,0,0-.1-1.761l-1.267-2.533a2.331,2.331,0,0,0-2.065-1.254ZM130.909,45.162Z",
    transform: "translate(8.007 3.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126586",
    "data-name": "Path 126586",
    d: "M4.991,0H15.466a3.585,3.585,0,0,1,3.585,3.585V6.4a3.585,3.585,0,0,1-3.585,3.585H4.991A4.991,4.991,0,0,1,0,4.991H0A4.991,4.991,0,0,1,4.991,0Z",
    transform: "matrix(0.897, -0.442, 0.442, 0.897, 120.053, 35.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126587",
    "data-name": "Path 126587",
    d: "M118.857,42.815a6.333,6.333,0,0,1-2.027-.342,6.257,6.257,0,0,1-.747-11.527l9.4-4.623a4.864,4.864,0,0,1,6.5,2.255l1.267,2.533a4.889,4.889,0,0,1-2.217,6.5l-9.4,4.623A6.333,6.333,0,0,1,118.857,42.815Zm8.765-14.453a2.293,2.293,0,0,0-1.026.241l-9.4,4.623a3.713,3.713,0,0,0,.443,6.853,3.648,3.648,0,0,0,2.85-.177l9.4-4.623a2.318,2.318,0,0,0,1.051-3.1l-1.267-2.533a2.331,2.331,0,0,0-2.052-1.279Z",
    transform: "translate(7.886 0.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126588",
    "data-name": "Path 126588",
    d: "M114.71,43.652v5.7a1.419,1.419,0,0,1-1.419,1.419h-10.45a1.431,1.431,0,0,1-1.431-1.419v-5.7a1.444,1.444,0,0,1,1.431-1.431h.709V40.092a4.522,4.522,0,1,1,9.031,0V42.22h.709a1.431,1.431,0,0,1,1.419,1.431ZM110.2,40.092a2.141,2.141,0,1,0-4.269,0V42.22H110.2Z",
    transform: "translate(4.901 3.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126589",
    "data-name": "Path 126589",
    d: "M89.921,110.733v-26.6L85.4,77.926c-2.027-2.787-3.129-10.412-3.129-13.857V42.231A5.231,5.231,0,0,1,87.5,37h0a5.231,5.231,0,0,1,5.231,5.231V62.7s11.4,1.659,15.073,10.564c.747,1.748,1.178,1.875,1.178,1.875h18.227c-1.077,6.169-4.37,8.867-6.625,10.133a4.142,4.142,0,0,0-2.217,3.661v21.8Z",
    transform: "translate(-0.203 3.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126590",
    "data-name": "Path 126590",
    d: "M102.99,66.5a14.5,14.5,0,0,0-2.66-4.155c3.382,3.8,3.914,10.133,3.927,13.617a2.533,2.533,0,0,0,2.837,2.407,35.631,35.631,0,0,0,9.741-2.926,9.8,9.8,0,0,0,5.561-7.03H104.168S103.712,68.24,102.99,66.5Z",
    transform: "translate(4.613 10.545)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126591",
    "data-name": "Path 126591",
    d: "M82.27,42.231V64.094c0,3.445,1.1,11.071,3.129,13.857l3.585,4.915a4.9,4.9,0,0,1,.937,2.875v24.991h8.867V96.369a5.978,5.978,0,0,1,.684-2.8c.329-.633.747-1.495,1.178-2.419a16.758,16.758,0,0,0,.709-12.958,8.349,8.349,0,0,0-.469-1.051A20.773,20.773,0,0,0,89.9,68.274a3.585,3.585,0,0,1-2.343-3.382V37a5.231,5.231,0,0,0-5.282,5.231Z",
    transform: "translate(-0.203 3.785)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126592",
    "data-name": "Path 126592",
    d: "M90.187,112.266A1.267,1.267,0,0,1,88.921,111V86.033a3.61,3.61,0,0,0-.7-2.153l-3.585-4.915c-2.242-3.078-3.369-11.02-3.369-14.6V42.5a6.5,6.5,0,1,1,13,0V61.929a26.6,26.6,0,0,1,7.5,2.926,16.53,16.53,0,0,1,8.753,14.82,1.267,1.267,0,0,1-2.533,0c0-13.085-15.023-15.428-15.2-15.453l-1.077-.165V42.523a3.965,3.965,0,0,0-7.929,0V64.361c0,3.648,1.153,10.741,2.888,13.11l3.572,4.915a6.08,6.08,0,0,1,1.191,3.648V111a1.267,1.267,0,0,1-1.242,1.267Z",
    transform: "translate(-0.469 3.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126593",
    "data-name": "Path 126593",
    d: "M111.037,104.234a1.267,1.267,0,0,1-1.267-1.267v-21.8a5.371,5.371,0,0,1,2.9-4.763c2.179-1.165,4.991-3.7,5.966-9.221a1.286,1.286,0,0,1,2.533.443c-1.2,6.865-5.067,9.842-7.283,11.007a2.875,2.875,0,0,0-1.545,2.533v21.8a1.267,1.267,0,0,1-1.3,1.267Z",
    transform: "translate(7.131 11.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126594",
    "data-name": "Path 126594",
    d: "M156.733,22H260.321a6.333,6.333,0,0,1,6.333,6.333v76H150.4v-76A6.333,6.333,0,0,1,156.733,22Z",
    transform: "translate(17.965 -0.215)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126595",
    "data-name": "Path 126595",
    d: "M139.865,87.05H282.834A10.336,10.336,0,0,1,272.5,97.386H150.176A10.336,10.336,0,0,1,139.84,87.05h.025Z",
    transform: "translate(15.149 17.132)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126596",
    "data-name": "Path 126596",
    d: "M149.712,96.053h122.3a10.323,10.323,0,0,0,8.17-4H141.58a10.323,10.323,0,0,0,8.132,4Z",
    transform: "translate(15.613 18.465)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126597",
    "data-name": "Path 126597",
    d: "M272.765,98.919H150.443a11.615,11.615,0,0,1-11.6-11.6,1.267,1.267,0,0,1,1.267-1.267H283.1a1.267,1.267,0,0,1,1.267,1.267A11.615,11.615,0,0,1,272.765,98.919ZM141.487,88.583a9.082,9.082,0,0,0,8.955,7.8h122.3a9.082,9.082,0,0,0,8.981-7.8Z",
    transform: "translate(14.883 16.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126598",
    "data-name": "Path 126598",
    d: "M268.2,105.917H149.4V28.65a7.6,7.6,0,0,1,7.6-7.6H260.6a7.6,7.6,0,0,1,7.6,7.6Zm-116.267-2.533H265.667V28.65a5.067,5.067,0,0,0-5.067-5.067H157a5.067,5.067,0,0,0-5.067,5.067Z",
    transform: "translate(17.699 -0.468)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11652",
    "data-name": "Rectangle 11652",
    width: 102.499,
    height: 69.223,
    rx: 2.787,
    transform: "translate(175.256 30.31)",
    fill: "#85b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126599",
    "data-name": "Path 126599",
    d: "M255.55,97.367H158.587a2.787,2.787,0,0,1-2.787-2.8L258.286,30.93V94.567a2.787,2.787,0,0,1-2.736,2.8Z",
    transform: "translate(19.405 2.167)",
    fill: "#6da2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126600",
    "data-name": "Path 126600",
    d: "M255.55,30a1.52,1.52,0,0,1,1.52,1.52V95.154a1.533,1.533,0,0,1-1.52,1.533H158.587a1.52,1.52,0,0,1-1.52-1.533V31.517a1.507,1.507,0,0,1,1.52-1.52H255.5m0-1.267H158.587a2.774,2.774,0,0,0-2.787,2.787V95.154a2.787,2.787,0,0,0,2.787,2.8H255.5a2.787,2.787,0,0,0,2.787-2.8V31.517A2.774,2.774,0,0,0,255.5,28.73Z",
    transform: "translate(19.405 1.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126601",
    "data-name": "Path 126601",
    d: "M214.059,59.56V72.138a3.154,3.154,0,0,1-3.141,3.154H187.851a3.154,3.154,0,0,1-3.141-3.154V59.56a3.141,3.141,0,0,1,3.141-3.141h1.571V51.694a9.969,9.969,0,0,1,19.925,0v4.725h1.571A3.141,3.141,0,0,1,214.059,59.56Zm-9.981-7.866a4.725,4.725,0,0,0-9.437,0v4.725h9.437Z",
    transform: "translate(27.115 5.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126602",
    "data-name": "Path 126602",
    d: "M196.719,28.489a2.027,2.027,0,1,1,1.455-.6A2.039,2.039,0,0,1,196.719,28.489Zm0-2.8a.773.773,0,1,0,.773.773.76.76,0,0,0-.773-.773Z",
    transform: "translate(29.773 0.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126603",
    "data-name": "Path 126603",
    d: "M396.213,96.743H18.747a1.267,1.267,0,1,1,0-2.533H396.213a1.267,1.267,0,1,1,0,2.533Z",
    transform: "translate(-17.48 19.041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllPassword);
export default __webpack_public_path__ + "static/media/ill_password.9a00c4b15627bd1ab65537865c8b62be.svg";
export { ForwardRef as ReactComponent };